<template>
  <div class="popupPage" v-if="visibility" @click="closeUp" @touchmove.prevent>
    <div :class="classStr" @touchmove.stop @click.stop>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
    isClose: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visibility: false,
      classStr: "",
      timer: false,
    };
  },
  mounted() {
    if (this.show) {
      this.openUp();
    }
  },
  watch: {
    show() {
      if (this.show) {
        this.openUp();
      } else {
        this.closeUp();
      }
    },
  },
  beforeDestroy() {
    document.body.style.overflow = "";
  },
  methods: {
    openUp() {
      if (this.timer) return;
      this.timer = true;
      setTimeout(() => {
        this.timer = false;
      }, 300);
      document.body.style.overflow = "hidden";
      this.visibility = true;
      this.classStr = `${this.name}`;
      setTimeout(() => {
        this.classStr = `${this.name} ${this.name}-on`;
      }, 40);
    },
    closeUp() {
      if (this.isClose) return;
      if (this.timer) return;
      this.timer = true;
      document.body.style.overflow = "";
      this.classStr = `${this.name}`;
      setTimeout(() => {
        this.timer = false;
        this.visibility = false;
        this.$emit("update:show", false);
        this.$emit("close");
      }, 300);
    },
  },
};
</script>

<style scoped lang="scss">
.popupPage {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 600;
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slideUp {
  transform: translateY(50%);
  opacity: 0;
  transition: all 0.3s linear;
}
.slideUp-on {
  transform: translateY(0);
  opacity: 1;
}

.scale {
  transform: scale(0.9);
  opacity: 0;
  transition: all 0.3s linear;
}
.scale-on {
  transform: scale(1);
  opacity: 1;
}
</style>
